export default __webpack_public_path__ + "static/logo-2d8fc8ea6d12bcf33a5fc0e8a090cc32.png";